/* ============================================================
   VERGLEICHSTEST – Landing Page JS
   - Animiert Score-Balken beim Scrollen (data-vt-score)
   - Progressive Enhancement, ohne Abhaengigkeiten
   ============================================================ */
(function () {
  "use strict";

  function fillBar(el) {
    var target = parseFloat(el.getAttribute("data-vt-score")) || 0;
    var max = parseFloat(el.getAttribute("data-vt-max")) || 10;
    var pct = Math.max(0, Math.min(100, (target / max) * 100));
    el.style.width = pct + "%";
  }

  function initScores() {
    var bars = document.querySelectorAll("[data-vt-score]");
    if (!bars.length) return;

    var prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced || !("IntersectionObserver" in window)) {
      bars.forEach(fillBar);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fillBar(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    bars.forEach(function (bar) {
      observer.observe(bar);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScores);
  } else {
    initScores();
  }
})();
